import { useCallback, useEffect, useState } from "react";
import { OperatingSystems } from "../utils/vendor";
import { checkBrowser, checkOs } from "../utils/helpers";

export default function useDeviceInfo() {
  const [os, setOs] = useState<OperatingSystems>();
  const [browserIsChrome, setBrowserIsChrome] = useState<boolean>(false);

  const isBrowserChrome = useCallback(() => {
    const browser = checkBrowser();
    if (browser?.match(/Chrome/i)) setBrowserIsChrome(true);
  }, []);

  useEffect(() => {
    isBrowserChrome();
    const operatingSystem = checkOs();
    setOs(operatingSystem);
  }, [isBrowserChrome]);

  return {
    os,
    browserIsChrome,
  };
}
